module.exports = "/_next/static/images/img__main_small-f335cf34ea50c1a63fa7e3782a1e2bdc.png";